import { action, computed, observable } from 'mobx';
import { shinkansenApi } from '@link/triplabo/services';
import {
  LANGUAGE_CODE_MAP,
  LanguageCodeType
} from '@link/triplabo/services/shinkansen/consts';
import type {
  GetBannerListResponse,
  SearchDiagramsRequest,
  GetStationListResponse
} from '@link/triplabo/services/shinkansen/types';

export class Shinkansen {
  @observable accessor stationLoading: boolean = false;
  @observable accessor bannerLoading: boolean = false;
  @observable accessor stationList: GetStationListResponse | null = null;
  @observable accessor bannerList: GetBannerListResponse | null = null;

  @action
  getStationList(languageCode: LanguageCodeType) {
    this.setStationLoading(true);
    shinkansenApi
      .getStationList({
        commonRequestLanguageCode: LANGUAGE_CODE_MAP[languageCode]
      })
      .then(res => {
        this.setStationList(res);
      })
      .finally(() => {
        this.setStationLoading(false);
      });
  }

  @action
  setStationLoading(loading: boolean) {
    this.stationLoading = loading;
  }

  @action
  setStationList(stationList: GetStationListResponse) {
    this.stationList = stationList;
  }

  @action
  getBannerList(languageCode: LanguageCodeType) {
    this.setBannerLoading(true);
    shinkansenApi
      .getBannerList({
        commonRequestLanguageCode: LANGUAGE_CODE_MAP[languageCode]
      })
      .then(res => {
        this.setBannerList(res);
      })
      .finally(() => {
        this.setBannerLoading(false);
      });
  }

  @action
  setBannerLoading(loading: boolean) {
    this.bannerLoading = loading;
  }

  @action
  setBannerList(bannerList: GetBannerListResponse) {
    this.bannerList = bannerList;
  }

  @action
  searchDiagrams(request: SearchDiagramsRequest) {
    return shinkansenApi.searchDiagrams(request);
  }

  @computed
  get orderableDateFrom() {
    return this.stationList?.orderableDateFrom ?? '';
  }

  @computed
  get orderableDateTo() {
    return this.stationList?.orderableDateTo ?? '';
  }

  @computed
  get prefectures() {
    return this.stationList?.prefectures ?? [];
  }

  @computed
  get orderableTimeRanges() {
    return this.stationList?.orderableTimeRanges ?? [];
  }

  @computed
  get firstOrderableDateTimeRanges() {
    return this.stationList?.firstOrderableDateTimeRanges ?? [];
  }
}

export default new Shinkansen();
